function injectSameDayShippingMsg() {
  const shippingMsg = $(".free_shipping_msg.apl-section-shipping");
  if (
    shippingMsg.length &&
    shippingMsg.is(":visible") &&
    !$(".same-day-delivery-note").length
  ) {
    const newMsg = `
      <p class="same-day-delivery-note" style="margin-top: 4px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
          <path d="M1.89353 9.84661C1.43772 9.84661 1.09151 9.72831 0.854906 9.49171C0.618302 9.2551 0.5 8.9089 0.5 8.45308V1.7464C0.5 1.28711 0.618302 0.939166 0.854906 0.702562C1.09151 0.465958 1.43772 0.347656 1.89353 0.347656H9.40919C9.865 0.347656 10.2112 0.467698 10.4478 0.707782C10.6844 0.947865 10.8027 1.29407 10.8027 1.7464V9.02198L10.1608 9.39776V1.75684C10.1608 1.50284 10.0946 1.31321 9.96242 1.18795C9.8302 1.05921 9.64057 0.994838 9.39353 0.994838H1.90397C1.65344 0.994838 1.46381 1.05921 1.33507 1.18795C1.20633 1.31321 1.14196 1.50284 1.14196 1.75684V8.43743C1.14196 8.69143 1.20633 8.8828 1.33507 9.01154C1.46381 9.14028 1.65344 9.20465 1.90397 9.20465H2.89562V9.84661H1.89353ZM10.4322 3.88628V3.24432H12.2902C12.5303 3.24432 12.7356 3.27737 12.9061 3.34348C13.08 3.40959 13.2383 3.51919 13.381 3.67229L15.1555 5.67647C15.2843 5.8226 15.373 5.967 15.4217 6.10966C15.4739 6.25232 15.5 6.43499 15.5 6.65768V8.45308C15.5 8.9089 15.3817 9.2551 15.1451 9.49171C14.9085 9.72831 14.5623 9.84661 14.1065 9.84661H13.3601V9.20465H14.0908C14.3413 9.20465 14.531 9.14028 14.6597 9.01154C14.7919 8.8828 14.858 8.69143 14.858 8.43743V6.64202C14.858 6.54111 14.8389 6.44021 14.8006 6.33931C14.7624 6.23492 14.7067 6.14098 14.6336 6.05747L12.9426 4.1629C12.8452 4.05503 12.7408 3.98196 12.6294 3.94369C12.5181 3.90542 12.3876 3.88628 12.238 3.88628H10.4322ZM11.7422 6.64202C11.6239 6.64202 11.5282 6.60722 11.4551 6.53764C11.3855 6.46805 11.3507 6.3741 11.3507 6.2558V4.41864H12.1284C12.2189 4.41864 12.2989 4.43777 12.3685 4.47605C12.4381 4.51084 12.5007 4.55782 12.5564 4.61697L14.1117 6.3654C14.15 6.40716 14.1795 6.44891 14.2004 6.49066C14.2248 6.53242 14.237 6.58287 14.237 6.64202H11.7422ZM4.27349 11.3341C3.95338 11.3341 3.6611 11.2558 3.39666 11.0992C3.1357 10.9426 2.92693 10.7321 2.77035 10.4677C2.61378 10.2067 2.53549 9.9162 2.53549 9.59609C2.53549 9.27598 2.61378 8.98544 2.77035 8.72448C2.92693 8.46004 3.1357 8.25128 3.39666 8.09818C3.6611 7.9416 3.95338 7.86331 4.27349 7.86331C4.5936 7.86331 4.88413 7.9416 5.14509 8.09818C5.40605 8.25128 5.61482 8.46004 5.7714 8.72448C5.92798 8.98544 6.00626 9.27598 6.00626 9.59609C6.00626 9.9162 5.92798 10.2067 5.7714 10.4677C5.61482 10.7321 5.40605 10.9426 5.14509 11.0992C4.88413 11.2558 4.5936 11.3341 4.27349 11.3341ZM4.27349 10.7756C4.48921 10.7756 4.6858 10.7217 4.86326 10.6138C5.04419 10.5095 5.18685 10.3668 5.29123 10.1859C5.39562 10.0084 5.44781 9.81182 5.44781 9.59609C5.44781 9.37688 5.39562 9.17855 5.29123 9.0011C5.18685 8.82365 5.04419 8.68273 4.86326 8.57835C4.6858 8.47048 4.48921 8.41655 4.27349 8.41655C4.05428 8.41655 3.85595 8.47048 3.6785 8.57835C3.50104 8.68273 3.35839 8.82365 3.25052 9.0011C3.14266 9.17855 3.08873 9.37688 3.08873 9.59609C3.08873 9.81182 3.14266 10.0084 3.25052 10.1859C3.35839 10.3668 3.50104 10.5095 3.6785 10.6138C3.85595 10.7217 4.05428 10.7756 4.27349 10.7756ZM11.8622 11.3341C11.5456 11.3341 11.255 11.2558 10.9906 11.0992C10.7262 10.9426 10.5157 10.7321 10.3591 10.4677C10.2025 10.2067 10.1242 9.9162 10.1242 9.59609C10.1242 9.27598 10.2025 8.98544 10.3591 8.72448C10.5157 8.46004 10.7262 8.25128 10.9906 8.09818C11.255 7.9416 11.5456 7.86331 11.8622 7.86331C12.1823 7.86331 12.4729 7.9416 12.7338 8.09818C12.9983 8.25128 13.207 8.46004 13.3601 8.72448C13.5167 8.98544 13.595 9.27598 13.595 9.59609C13.595 9.9162 13.5167 10.2067 13.3601 10.4677C13.207 10.7321 12.9983 10.9426 12.7338 11.0992C12.4729 11.2558 12.1823 11.3341 11.8622 11.3341ZM11.8622 10.7756C12.0814 10.7756 12.2797 10.7217 12.4572 10.6138C12.6347 10.5095 12.7756 10.3668 12.88 10.1859C12.9843 10.0084 13.0365 9.81182 13.0365 9.59609C13.0365 9.37688 12.9826 9.17855 12.8747 9.0011C12.7704 8.82365 12.6294 8.68273 12.452 8.57835C12.2745 8.47048 12.0779 8.41655 11.8622 8.41655C11.6465 8.41655 11.4499 8.47048 11.2724 8.57835C11.095 8.68273 10.9523 8.82365 10.8445 9.0011C10.7366 9.17855 10.6827 9.37688 10.6827 9.59609C10.6827 9.81182 10.7366 10.0084 10.8445 10.1859C10.9523 10.3668 11.095 10.5095 11.2724 10.6138C11.4499 10.7217 11.6465 10.7756 11.8622 10.7756ZM5.70355 9.84661V9.20465H10.4896V9.84661H5.70355Z" fill="black"></path>
        </svg>
        <b>Same Day Delivery :</b> Working Day Before 5pm<br>
        <small>*Exclude pre-order product</small>
      </p>`;
    shippingMsg.after(newMsg);
    // console.log("✅ Same-day shipping message injected");
  }
}

function movePickupSection() {
  const $pickup = $("#pickup_id");
  if ($pickup.length && !$pickup.closest(".pickup-extension-grid").length) {
    const $wrapper = $('<div class="pickup-extension-grid"></div>');
    $pickup.wrap($wrapper);
    $(".one-pickup").after($(".pickup-extension-grid"));
    // console.log("✅ Pickup section moved");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  injectSameDayShippingMsg();
  movePickupSection();

  function reapplyOnMutation(mutations) {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        injectSameDayShippingMsg();
        movePickupSection();
        break;
      }
    }
  }

  // Watch the main product info container (PDP body)
  const productInfoContainer = document.querySelector(".product__info-container");
  if (productInfoContainer) {
    new MutationObserver(reapplyOnMutation).observe(productInfoContainer, {
      childList: true,
      subtree: true,
    });
  }

  // [MACHINES CUSTOM] Also watch the sticky footer — variant selection re-renders
  // .one-pickup inside .js-sticky-atc, which removes the injected
  // .same-day-delivery-note and .pickup-extension-grid.
  const stickyBar = document.querySelector(".js-sticky-atc");
  if (stickyBar) {
    new MutationObserver(reapplyOnMutation).observe(stickyBar, {
      childList: true,
      subtree: true,
    });
  }
});





//start sticky pickup availability
if (document.body.dataset.template === 'product') {
  // console.log("Product page detected. Overriding pickup-availability preview.");

  // start: sticky footer pickup-availability
  customElements.whenDefined('pickup-availability').then(() => {
    const PickupAvailability = customElements.get('pickup-availability');

    if (PickupAvailability?.prototype?.renderPreview) {
      PickupAvailability.prototype.renderPreview = function(location) {
        // console.log("Running custom renderPreview on product page");

        try {
          // Reference
          const itemKey = this.dataset.itemKey;
          const itemsAdded = parseInt(this.dataset.itemQuantity || '0', 10);

          // Replace location if item-specific match found
          if (itemKey && location) {
            const allItemLocations = this.storeLocator?.itemLocationsData?.[itemKey];
            if (Array.isArray(allItemLocations)) {
              const matched = allItemLocations.find(loc => loc?.id === location.id);
              if (matched) location = matched;
            }
          }

          // Guard: skip DOM rebuild if the location data hasn't changed since last
          // render. renderPreview() is called multiple times per page load (loading
          // state, store selection, variant change) — without this guard each call
          // clears info.innerHTML and rebuilds, causing visible flicker.
          const renderKey = location
            ? `${location.id}|${location.quantityAvailable}|${location.available}|${itemsAdded}`
            : 'no-location';
          if (this._mwRenderKey === renderKey) return;
          this._mwRenderKey = renderKey;

          this.info.innerHTML = '';
          const buttonText = location?.name || this.storeLocator?.dataset?.viewStoreAvailabilityText || 'View store availability';

          let availabilityHtml = '';
          let timeHtml = '';

          if (location) {
            this.dataset.quantityAvailable = location.quantityAvailable;
            
            // console.log("Location Available  -- "+location.quantityAvailable);

            const qty = Number(location.quantityAvailable);
            const message = this.preOrderMessageContainer?.innerHTML?.trim();

            // Availability Status Message
            if (location.available) {
              if (qty <= 0) {
                // Continue-selling at zero stock — treat same as unavailable
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__time">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>
                  </p>
                `;
              } else if (message) {
                const isReadyStock = message.toLowerCase() === "ready stock";
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__time" style="color:#0071e3">
                      ${message}${isReadyStock ? ". Get It Today!" : ""}
                    </span>
                  </p>
                `;
              } else {
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__time">Usually ready in 30 minutes*</span>
                  </p>
                `;
              }

              // Status badge — hide when qty <= 0 (show nothing instead of "Sold Out")
              if (qty > 0) {
                const [statusClass, statusText] = qty <= 5
                  ? ['pickup-availability__limited', 'Limited']
                  : ['pickup-availability__available', 'Available'];

                availabilityHtml = `
                  <p class="caption">
                    <span class="${statusClass}">${statusText}</span>
                  </p>
                `;
              }

              // If added quantity exceeds available
              if (itemsAdded > qty) {
                timeHtml = `
                  <p class="caption">
                    <span class="pickup-availability__error">${this.dataset.error}</span>
                  </p>
                `;
              }

            } else {
              // Not available case

              // start Convx : Ruby - #3243

              // availabilityHtml = `
              //   <p class="caption">
              //     <span style="color:#FF0000;">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>
              //   </p>
              // `;
              const checkMsg = document.querySelector('.desktop-view_Product-title .product__preorder-message');
              if(checkMsg && checkMsg.textContent && checkMsg.textContent != 'Ready Stock'){
                availabilityHtml = `
                  <p class="caption">
                    <span style="color:#FF0000;">${checkMsg.textContent}</span>
                  </p>
                `;
              }else{
                availabilityHtml = `
                  <p class="caption">
                    <span style="color:#FF0000;">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>
                  </p>
                `;
              }
              // end of #3243
            }
          }

          // Build preview content safely
          const html = `
            <div>
              ${availabilityHtml}
              ${timeHtml}
              <button
                class="js-my-store-locator-drawer-btn pickup-availability-button link link--text underlined-link"
                aria-haspopup="dialog"
                ${itemKey ? `data-item-key="${itemKey}"` : ''}
              >
                ${buttonText}
              </button>
            </div>
          `;

          const safeNode = new DOMParser().parseFromString(html, 'text/html').body.firstChild;
          if (safeNode) this.info.append(safeNode);

          // Attach store locator event
          const button = this.querySelector('button.js-my-store-locator-drawer-btn');
          if (button) {
            button.addEventListener('click', (evt) => {
              evt.preventDefault();
              this.storeLocatorDrawer.selectedItemLocationsKey = null;

              const selected = this.storeLocator?.itemLocationsData?.[itemKey];
              if (itemKey && selected) {
                this.storeLocatorDrawer.selectedItemLocationsKey = itemKey;
                this.storeLocatorDrawer.updateStoreDetails(selected, '');
              }

              this.storeLocatorDrawer.show(evt.currentTarget);
            });
          }
        } catch (err) {
          console.error('PickupAvailability renderPreview error:', err);
        }
      };
    }
  });
  // end 
}

// pickup right sticky drawer: stock/time display + address shortening
document.addEventListener("DOMContentLoaded", function () {
  const drawerEl = document.querySelector("my-store-locator-drawer");
  if (!drawerEl) return;

  const originalUpdate = drawerEl.updateStoreDetails;

  drawerEl.updateStoreDetails = function (locationData, nearbyValue) {
    // Query once outside loop — same element for all locations
    const checkMsg = document.querySelector('.desktop-view_Product-title .product__preorder-message');
    const preorderText = checkMsg?.textContent && checkMsg.textContent !== 'Ready Stock'
      ? checkMsg.textContent
      : null;
    const notReadyHtml = preorderText
      ? `<span class='machines-stock-status status-notready'>${preorderText}</span>`
      : "<span class='machines-stock-status status-notready'>Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span>";

    locationData.forEach((location) => {
      const rawQty = location.quantityAvailable;
      const hasQty = typeof rawQty !== 'undefined' && rawQty !== null;
      const qty = hasQty ? parseInt(rawQty, 10) : null;

      let timeText = "";
      let stockText = "";

      if (!hasQty) {
        if (qty > 10) {
          timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes*</span>";
          stockText = "<span class='machines-stock-label status-available'>Available</span>";
        } else {
          timeText = notReadyHtml;
          stockText = "";
        }
      } else if (qty <= 0) {
        timeText = notReadyHtml;
        stockText = "";
      } else if (qty <= 5) {
        timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes*</span>";
        stockText = "<span class='machines-stock-label status-limited'>Limited</span>";
      } else {
        timeText = "<span class='machines-stock-status status-ready'>Usually ready in 30 minutes*</span>";
        stockText = "<span class='machines-stock-label status-available'>Available</span>";
      }

      location.customAvailabilityTime = timeText;
      location.customAvailabilityStock = stockText;
    });

    originalUpdate.call(this, locationData, nearbyValue);

    // Patch stock/time HTML
    this.querySelectorAll(".js-my-location-result").forEach((el) => {
      const id = el.dataset.id;
      const location = locationData.find((loc) => loc.id === id);
      if (!location) return;

      const availabilityWrapper = el.querySelector(".my-location-result__availability");
      if (availabilityWrapper) {
        availabilityWrapper.innerHTML = "";
      }

      const timeEl = document.createElement("div");
      timeEl.className = "my-location-result__availability-time";
      timeEl.innerHTML = location.customAvailabilityTime;
      availabilityWrapper?.appendChild(timeEl);

      const stockEl = document.createElement("div");
      stockEl.className = "my-location-result__availability-stock";
      stockEl.innerHTML = location.customAvailabilityStock || "";
      availabilityWrapper?.appendChild(stockEl);
    });

    // Shorten address display
    this.querySelectorAll(".my-location-result__address").forEach((el) => {
      const anchor = el.querySelector("a[href^='http']");
      if (!anchor) return;
      const parts = anchor.textContent.split(",").map(s => s.trim());
      anchor.textContent = parts.slice(0, 4).join(", ");
    });
  };
});

document.addEventListener('DOMContentLoaded', function () {
  // Listen for tab button clicks
  document.querySelectorAll('.sdd-tab-buttons button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Remove "active" class from all buttons and tab contents
      document.querySelectorAll('.sdd-tab-buttons button').forEach(function(b){ b.classList.remove('active'); });
      document.querySelectorAll('.sdd-tab-content').forEach(function(tab){ tab.classList.remove('active'); });

      // Add "active" to this button and matching content
      btn.classList.add('active');
      var tabId = btn.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.accordion-header');
  headers.forEach((header) => {
    header.addEventListener('click', function() {
      if (header.classList.contains('active')) return;
      headers.forEach(h => {
        h.classList.remove('active');
        h.querySelector('.accordion-icon').textContent = '+';
      });
      document.querySelectorAll('.accordion-content').forEach(c => c.classList.remove('show'));
      header.classList.add('active');
      header.querySelector('.accordion-icon').textContent = '-';
      header.nextElementSibling.classList.add('show');
    });
  });

  const firstHeader = document.querySelector('.accordion-header');
  const firstContent = document.querySelector('.accordion-content');
  if (firstHeader && firstContent) {
    firstHeader.classList.add('active');
    firstHeader.querySelector('.accordion-icon').textContent = '-';
    firstContent.classList.add('show');
  }
});

// main cart — pickup availability time override
// [MACHINES CUSTOM] Force ".pickup-availability__time" to always show
// "Usually ready in 30 minutes*" on the cart page.
//
// Why two layers are needed:
//   1. MutationObserver — fires on every DOM change inside #main-cart-items,
//      including the initial cart render. Catches inline/synchronous updates.
//   2. cart-update pubsub — fires after Shopify's cart AJAX completes (Remove,
//      qty change, etc.). The core <pickup-availability> custom element then
//      makes its OWN async API call to Shopify Store Availability, which can
//      take 500 ms–2 s. We schedule two deferred passes (800 ms + 1500 ms) so
//      we correct the text after that API call finishes and rewrites the DOM.
//   No server requests are made by this code.
(function () {
  const PREORDER_MSG = 'Usually ready in 2-4 working days<br>(Pre-orders follow batches)';
  const INSTOCK_MSG  = 'Usually ready in 30 minutes*';

  function applyPickupTimeOverrides() {
    const cartContainer = document.querySelector('#main-cart-items');
    if (!cartContainer) return;

    // --- Unavailable / pre-order label ---
    // Core renders this as plain text inside <p> (no inner span) when
    // location.available === false and no overrideUnavailableMessage is set.
    cartContainer.querySelectorAll('.apl-section-pickup-availability-unavailable').forEach(unavailP => {
      if (unavailP.dataset.mwDone !== '1') {
        unavailP.innerHTML      = PREORDER_MSG;
        unavailP.dataset.mwDone = '1';
      }
    });

    // --- Time label ---
    // Query all time spans in the cart container (not just inside .cart_itemadd)
    // to cover elements that may sit outside the per-item wrapper.
    // qty check removed: the store always wants the 30-min message for in-stock
    // items; pre-orders are caught by the unavailP block above.
    cartContainer.querySelectorAll('.pickup-availability__time').forEach(timeEl => {
      if (timeEl.dataset.mwTime !== INSTOCK_MSG) {
        timeEl.innerHTML      = INSTOCK_MSG;
        timeEl.dataset.mwTime = INSTOCK_MSG;
      }
    });

    // --- Stock label (hidden via CSS, value kept correct for reference) ---
    cartContainer.querySelectorAll('.cart_itemadd').forEach(cartItem => {
      const stockEl  = cartItem.querySelector('.pickup-availability__stock');
      const pickupEl = cartItem.querySelector('pickup-availability[data-quantity-available]');
      if (!stockEl || !pickupEl) return;

      const qty = parseInt(pickupEl.dataset.quantityAvailable, 10);
      const stockLabel = (isNaN(qty) || qty <= 0) ? 'Sold Out'
                       : qty <= 5                  ? 'Limited'
                       :                            'Available';
      if (stockEl.dataset.mwStock !== stockLabel) {
        stockEl.textContent     = stockLabel;
        stockEl.dataset.mwStock = stockLabel;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const cartContainer = document.querySelector('#main-cart-items');
    if (!cartContainer) return;

    // Layer 1: MutationObserver — immediate + short-deferred correction
    let debounceTimer;
    const observer = new MutationObserver(() => {
      applyPickupTimeOverrides();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyPickupTimeOverrides, 350);
    });
    observer.observe(cartContainer, { childList: true, subtree: true });

    // Layer 2: cart-update pubsub — fires after Remove / qty-change AJAX.
    // pickup-availability.js then makes its own async Store Availability fetch;
    // two staggered passes cover slow connections without polling.
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function () {
        setTimeout(applyPickupTimeOverrides, 800);
        setTimeout(applyPickupTimeOverrides, 1500);
      });
    }
  });
})();


document.addEventListener('DOMContentLoaded', function () {
  function initFeatureReadMore(scope = document) {
    const wraps = scope.querySelectorAll('.feature-value-wrap');

    wraps.forEach(function (wrap) {
      const content = wrap.querySelector('.feature-list-collapse');
      const button = wrap.querySelector('.feature-readmore-btn');

      if (!wrap || !content || !button) return;

      const items = content.querySelectorAll('ul li');

      /* reset state first */
      wrap.dataset.readmoreInit = 'true';
      content.classList.remove('is-collapsed');
      button.hidden = true;
      button.textContent = 'Read more';

      if (!items.length || items.length <= 3) {
        return;
      }

      content.classList.add('is-collapsed');
      button.hidden = false;

      /* avoid duplicate event binding */
      if (button.dataset.readmoreBound === 'true') return;
      button.dataset.readmoreBound = 'true';

      button.addEventListener('click', function () {
        const isCollapsed = content.classList.contains('is-collapsed');

        if (isCollapsed) {
          content.classList.remove('is-collapsed');
          button.textContent = 'Read less';
        } else {
          content.classList.add('is-collapsed');
          button.textContent = 'Read more';
        }
      });
    });
  }

  initFeatureReadMore();

  /* watch for variant/section HTML replacement */
  const observer = new MutationObserver(function (mutations) {
    let shouldInit = false;

    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.matches?.('.feature-value-wrap, .js-features, .js-features-value') ||
            node.querySelector?.('.feature-value-wrap, .js-features, .js-features-value')
          ) {
            shouldInit = true;
          }
        });
      }
    });

    if (shouldInit) {
      initFeatureReadMore();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// --- Suppress Shopify customer privacy retry log ---
(function () {
  if (window.console && window.console.log) {
    const originalLog = console.log;
    console.log = function (...args) {
      if (args && args[0] && typeof args[0] === 'string' && args[0].includes('Shopify.customerPrivacy not yet available')) {
        // Suppress only that message
        return;
      }
      originalLog.apply(console, args);
    };
  }
})();


// ─── PLP: Color swatch image swap ────────────────────────────────────────────
(function initPLPSwatches() {

  // Machines William: hide empty swatch containers directly
  function hideEmptySwatchContainers() {
    document.querySelectorAll('.desktop-color-swatch-selection').forEach(function(container) {
      // Hide if no color swatch labels
      var swatches = container.querySelectorAll('label.color-swatch');
      if (!swatches.length) {
        container.style.cssText = 'display:none !important';
        return;
      }

      // Hide if all swatches have invalid/transparent background color
      // Real color swatches have actual colors (silver, orange, blue)
      // Non-color swatches have invalid CSS values (physical, card)
      var allInvalidColors = true;
      swatches.forEach(function(swatch) {
        var bg = window.getComputedStyle(swatch).backgroundColor;
        // Valid color = rgb/rgba value, invalid = rgba(0,0,0,0) or transparent
        if (bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
          allInvalidColors = false;
        }
      });
      if (allInvalidColors) {
        container.style.cssText = 'display:none !important';
        return;
      }

      // Hide if color images only has 1 or fewer options
      var radios = container.querySelector('variant-radios1[data-color-images]');
      if (radios) {
        try {
          var colorImages = JSON.parse(radios.dataset.colorImages || '{}');
          if (Object.keys(colorImages).length <= 1) {
            container.style.cssText = 'display:none !important';
            return;
          }
        } catch(e) {}
      }
    });
  }
  // end Machines William

  function bindSwatchImageSwap(imageCol) {
    const swatches = imageCol.querySelectorAll(
      '.desktop-color-swatch-selection label.color-swatch'
    );
    const radios1 = imageCol.querySelector('variant-radios1[data-color-images]');

    // Machines William: hide empty swatch container if no swatches or color images
    const swatchContainer = imageCol.querySelector('.desktop-color-swatch-selection');
    if (!swatches.length || !radios1) {
      if (swatchContainer) swatchContainer.style.display = 'none';
      return;
    }

    // Also hide if color images only has one option (no real color variants)
    try {
      const colorImages = JSON.parse(radios1.dataset.colorImages || '{}');
      if (Object.keys(colorImages).length <= 1) {
        if (swatchContainer) swatchContainer.style.display = 'none';
        return;
      }
    } catch(e) {}
    // end Machines William

    const isMobileCol = imageCol.classList.contains('image-with-text__content');
    const productImg  = isMobileCol
      ? imageCol.querySelector('.image_with_text_media_img--mobile img')
      : imageCol.querySelector('.image_with_text_media_img img');

    if (!productImg) return;

    let colorImageMap = {};
    try {
      colorImageMap = JSON.parse(radios1.dataset.colorImages || '{}');
    } catch (e) {
      console.warn('PLP swatch: could not parse color image map', e);
      return;
    }

    function setImage(url) {
      productImg.srcset = '';
      productImg.src    = url;
    }

    function markActiveSwatch(activeInput) {
      imageCol.querySelectorAll(
        '.desktop-color-swatch-selection label.color-swatch'
      ).forEach(function (lbl) {
        lbl.classList.remove('is-active');
      });
      if (activeInput) {
        const activeLabel = imageCol.querySelector(
          'label[for="' + CSS.escape(activeInput.id) + '"]'
        );
        if (activeLabel) activeLabel.classList.add('is-active');
      }
    }

    const initialChecked = imageCol.querySelector(
      '.desktop-color-swatch-selection input[type="radio"]:checked'
    );
    markActiveSwatch(initialChecked);

    if (initialChecked) {
      const initialColor = (initialChecked.value || '').trim();
      const initialUrl   = colorImageMap[initialColor];
      if (initialUrl) setImage(initialUrl);
    }

    swatches.forEach(function (swatch) {
      const inputId = swatch.getAttribute('for');
      const input   = inputId
        ? imageCol.querySelector('#' + CSS.escape(inputId))
        : null;

      swatch.addEventListener('click', function () {
        const color = input ? (input.value || '').trim() : '';
        const url   = colorImageMap[color];
        if (url) setImage(url);
        if (input) {
          input.checked = true;
          markActiveSwatch(input);
        }
      });
    });
  }

  function bindCloserLookButton(imageCol) {
    const btn = imageCol.querySelector('[data-quick-view-button]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const parts  = (btn.dataset.quickViewButton || '').split('|');
      const handle = parts[1] || parts[0];
      btn.dispatchEvent(new CustomEvent('plp:quick-view', {
        bubbles: true,
        detail: { handle: handle }
      }));
    });
  }

  function bindAllCards() {
    hideEmptySwatchContainers(); // Machines William: hide empty swatches
    document.querySelectorAll('.image_with_text_div_1').forEach(function (imageCol) {
      if (imageCol.dataset.swatchBound === 'true') return;
      if (!imageCol.querySelector('.collection-prod-color-closer-look-container')) return;
      imageCol.dataset.swatchBound = 'true';
      bindSwatchImageSwap(imageCol);
      bindCloserLookButton(imageCol);
    });

    document.querySelectorAll('.image-with-text__content').forEach(function (contentCol) {
      if (contentCol.dataset.swatchBound === 'true') return;
      if (!contentCol.querySelector('.collection-prod-color-closer-look-container')) return;
      contentCol.dataset.swatchBound = 'true';
      bindSwatchImageSwap(contentCol);
      bindCloserLookButton(contentCol);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideEmptySwatchContainers(); // Machines William
    bindAllCards();

    const plpRoot = document.querySelector('#product-grid, .collection, main');
    if (!plpRoot) return;
    new MutationObserver(bindAllCards)
      .observe(plpRoot, { childList: true, subtree: true });
  });

})();
// ─── End PLP Color swatch image swap ─────────────────────────────────────────


// ─── PWP Add-on Cart Handler — machines-PWP-iPhone ───────────────────────────
(function initPWPAddon() {

  var originalFetch = window.fetch;

  window.fetch = function(url, options) {
    var isCartAdd = typeof url === 'string' && url.includes('cart/add.js');
    var isPost = options && options.method && options.method.toLowerCase() === 'post';

    if (isCartAdd && isPost) {
      var promoContainer = document.querySelector('.promo-banner-scrollable input[type="checkbox"][name="promo_addon"]');
      var selectedAddon = document.querySelector('.promo-banner-scrollable input[type="checkbox"][name="promo_addon"]:checked');

      if (promoContainer && selectedAddon) {
        var addonVariantId = parseInt(selectedAddon.value);
        var prodQuant = parseInt(document.getElementById('prodQuantity')?.value) || 1;

        try {
          var body = JSON.parse(options.body);

          if (body.items && Array.isArray(body.items)) {
            body.items.push({
              id: addonVariantId,
              quantity: prodQuant,
              properties: {
                _pwp_addon: 'true'
              }
            });
            options.body = JSON.stringify(body);
          }
        } catch(e) {
          console.warn('PWP: could not parse cart body', e);
        }
      }
    }

    return originalFetch.apply(this, arguments);
  };

})();
// ─── End PWP Add-on Cart Handler ─────────────────────────────────────────────



// ─── AppleCare + SecWarranty layout ──────────────────────────────────────
(function initAddonLayout() {
  function updateAddonLayout() {
    var applecare = document.querySelector('.applecare-replace');
    var secWarranty = document.querySelector('.secWarranty-replace');

    if (!applecare || !secWarranty) return;

    var applecareHasContent = applecare.innerHTML.trim() !== '';
    var secWarrantyHasContent = secWarranty.innerHTML.trim() !== '';

    // Check if wrapper already exists
    var existingWrapper = document.querySelector('.machines-addon-wrapper');

    if (applecareHasContent && secWarrantyHasContent) {
      // Both have content — wrap in flex row if not already wrapped
      if (!existingWrapper) {
        var wrapper = document.createElement('div');
        wrapper.className = 'machines-addon-wrapper';
        wrapper.style.cssText = 'display:flex; gap:12px; width:100%;';
        applecare.parentNode.insertBefore(wrapper, applecare);
        wrapper.appendChild(applecare);
        wrapper.appendChild(secWarranty);
      }

      applecare.style.cssText = 'width:50%; box-sizing:border-box;';
      secWarranty.style.cssText = 'width:50%; box-sizing:border-box;';

    } else {
      // Only one has content — remove wrapper if exists
      if (existingWrapper) {
        existingWrapper.parentNode.insertBefore(applecare, existingWrapper);
        existingWrapper.parentNode.insertBefore(secWarranty, existingWrapper);
        existingWrapper.remove();
      }

      applecare.style.cssText = 'width:100%;';
      secWarranty.style.cssText = 'width:100%;';
    }
  }

  document.addEventListener('DOMContentLoaded', updateAddonLayout);

  var observer = new MutationObserver(function() {
    // Remove existing wrapper before re-evaluating to avoid nesting issues
    var existingWrapper = document.querySelector('.machines-addon-wrapper');
    if (existingWrapper) {
      var applecare = existingWrapper.querySelector('.applecare-replace');
      var secWarranty = existingWrapper.querySelector('.secWarranty-replace');
      if (applecare) existingWrapper.parentNode.insertBefore(applecare, existingWrapper);
      if (secWarranty) existingWrapper.parentNode.insertBefore(secWarranty, existingWrapper);
      existingWrapper.remove();
    }
    updateAddonLayout();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var applecare = document.querySelector('.applecare-replace');
    var secWarranty = document.querySelector('.secWarranty-replace');
    if (applecare) observer.observe(applecare, { childList: true, subtree: true });
    if (secWarranty) observer.observe(secWarranty, { childList: true, subtree: true });
  });
})();
// ─── End AppleCare + SecWarranty layout ──────────────────────────────────




// Machines William: flag to prevent loop for Add to Cart button
var machinesPreorderInjecting = false;

$(document).on('click', '#footer-atc', function(evt) {

  // Safety patch for missing pdp_product_list
  if (!document.querySelector('.pdp_product_list')) {
    $('body').append('<input type="hidden" class="pdp_product_list" value="">');
  } else if (!$('.pdp_product_list').attr('value')) {
    $('.pdp_product_list').attr('value', '');
  }

  // Machines William: inject missing inputs for pre-order products
  var preorderInput = document.getElementById('main-pro-preorder');
  var variantInput = document.getElementById('main-product-variant');

  // Only intercept if pre-order AND variant ID is missing AND not already injecting
  if (!machinesPreorderInjecting && preorderInput && preorderInput.value === 'true' && (!variantInput || !variantInput.value)) {

    machinesPreorderInjecting = true;
    evt.stopImmediatePropagation();
    evt.preventDefault();

    fetch(window.location.pathname + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var variant = data.product.variants[0];
        var product = data.product;

        var values = {
          'main-product-variant': variant.id,
          'main-pro-sku': variant.sku,
          'main-pro-handle': product.handle,
          'main-pro-barcode': variant.barcode,
          'tax_tags': Array.isArray(product.tags) ? product.tags.join(',') : product.tags,
        };

        var missingInputs = {
          'main-product-variant': { class: 'product-variant-id', disabled: true },
          'main-pro-sku': {},
          'main-pro-handle': {},
          'main-pro-barcode': {},
          'tax_tags': {},
        };

        Object.keys(values).forEach(function(id) {
          var el = document.getElementById(id);
          if (!el || !el.value) {
            if (!el) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.id = id;
              if (missingInputs[id].class) input.className = missingInputs[id].class;
              if (missingInputs[id].disabled) input.disabled = true;
              input.value = values[id];
              document.body.appendChild(input);
            } else {
              el.value = values[id];
            }
          }
        });

        if (!document.querySelector('.pdp_product_list')) {
          var listInput = document.createElement('input');
          listInput.type = 'hidden';
          listInput.className = 'pdp_product_list';
          listInput.setAttribute('value', '');
          document.body.appendChild(listInput);
        }


        machinesPreorderInjecting = false;
        $('#footer-atc').trigger('click');
      })
      .catch(function(err) {
        console.error('machines: failed to fetch product JSON', err);
        machinesPreorderInjecting = false;
      });

    return false;
  }
});



// Adjustment on pre-order message
$(document).ready(function() {

  function ensurePreorderMessageElement() {
    var locations = [
      '.mobile-view_product-title',
      '.desktop-view_Product-title'
    ];

    locations.forEach(function(container) {
      var containerEl = document.querySelector(container);
      if (containerEl && !containerEl.querySelector('.product__preorder-message')) {
        var p = document.createElement('p');
        p.className = 'product__preorder-message check';
        containerEl.appendChild(p);
      }
    });
  }

  // Run on page load ← MISSING in your version
  ensurePreorderMessageElement();

  var preorderObserver = new MutationObserver(function() {
    ensurePreorderMessageElement();
    
    // Machines William: clear preorder message if not preorder variant
    var preorderInput = document.getElementById('main-pro-preorder');
    var isPreorder = preorderInput && preorderInput.value === 'true';
    
    if (!isPreorder) {
      document.querySelectorAll('.product__preorder-message').forEach(function(el) {
        el.innerHTML = '';
      });
    }
  });

  // Start observing ← MISSING in your version
  var stickyAtc = document.querySelector('.js-sticky-atc');
  if (stickyAtc) {
    preorderObserver.observe(stickyAtc, { childList: true, subtree: true });
  }

});



// Machines William: pickup availability fallback + safe store locator init
$(document).ready(function() {

  // Safe wrap store locator init to prevent null errors on variant switch
  function safewrapStoreLocator() {
    var storeLocatorEl = document.querySelector('my-store-locator');
    if (storeLocatorEl && typeof storeLocatorEl.init === 'function') {
      var originalInit = storeLocatorEl.init.bind(storeLocatorEl);
      storeLocatorEl.init = function() {
        try {
          originalInit();
        } catch(e) {
          console.warn('machines: store locator init error caught', e);
        }
      };
    }
  }

  // Fallback for pickup availability loading on pre-order SKU
  function initPickupAvailabilityFallback() {
    var pickupEl = document.querySelector('pickup-availability');
    if (!pickupEl) return;

    var preorderInput = document.getElementById('main-pro-preorder');
    var isPreorder = preorderInput && preorderInput.value === 'true';
    if (!isPreorder) return;

    // Wait 3 seconds — if still showing loading spinner, replace with unavailable
    setTimeout(function() {
      var spinner = pickupEl.querySelector('.fa-spinner');
      if (spinner) {
        var infoDiv = pickupEl.querySelector('.js-pickup-availability-info');
        if (infoDiv) {
          infoDiv.innerHTML = '<p class="caption"><span style="color:#FF0000;">Usually ready in 2-4 working days<br>(Pre-orders follow batches)</span></p>';
        }
      }
    }, 3000);
  }

  // Run on page load
  safewrapStoreLocator();
  initPickupAvailabilityFallback();

  // Single observer watching .js-sticky-atc — runs ONCE then disconnects.
  // [MACHINES CUSTOM] Disconnect before calling storeLocator.init() to prevent
  // a feedback loop: init() → renderLoading() updates .js-pickup-availability-info
  // → DOM change → observer fires → init() again → repeat every ~1 s.
  var stickyAtc = document.querySelector('.js-sticky-atc');
  if (stickyAtc) {
    var pdpObserver = new MutationObserver(function() {
      pdpObserver.disconnect(); // fire once only — prevents infinite loop
      safewrapStoreLocator();
      initPickupAvailabilityFallback();
      var storeLocator = document.querySelector('my-store-locator');
      if (storeLocator && typeof storeLocator.init === 'function') {
        try {
          storeLocator.init();
        } catch(e) {
          console.warn('machines: store locator init error', e);
        }
      }
    });

    pdpObserver.observe(stickyAtc, { childList: true, subtree: true });
  }

});
// End Machines William: pickup availability fallback + safe store locator init



// Machines William: exclude internal/dev collections from predictive search suggestions
$(document).ready(function() {

  var hiddenSearchPattern = /apl[_-]|machines[_-]|dev|quick checkout/i;
  function filterPredictiveSearchResults() {
    document.querySelectorAll('#predictive-search-results-queries-list .predictive-search__list-item').forEach(function(item) {
      if (hiddenSearchPattern.test(item.textContent.trim())) {
        item.style.display = 'none';
      }
    });
  }

  // Watch entire document body for predictive search results
  new MutationObserver(function() {
    filterPredictiveSearchResults();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run on input event directly
  $(document).on('input', '[data-predictive-search-input], .search__input, input[type="search"]', function() {
    setTimeout(function() {
      filterPredictiveSearchResults();
    }, 300);
  });

});
// End Machines William: predictive search filter

// Machines: override header account login URL
document.addEventListener('DOMContentLoaded', function () {
  var accountLink = document.querySelector('a.apl-section-header-account');
  if (accountLink && !accountLink.getAttribute('href').startsWith('/account')) {
    accountLink.setAttribute('href', '/account/login');
  }
});



// ─── Trade-In: clear localStorage when product with trade-in is removed ──────
// When a consumer removes the main product from cart, the trade-in data in
// localStorage is NOT cleared by the existing trade-in scripts (they only clear
// on "No trade-in" radio or trade-in card remove button). This causes stale
// trade-in data to persist and auto-apply to the next eligible product added.
// Fix: subscribe to the cart-update event and clear localStorage if no cart
// items have trade-in properties remaining after the update.
(function initTradeInCartRemoveGuard() {
  var STORAGE_KEYS = [
    'mw_instant_tradein',
    'trade-in-form-submitted',
    'quotation_id',
    'tradeInDetails',
  ];
  var DECLINED_KEY = 'machines-trade-in-declined';

  function hasStoredTradeIn() {
    try { return !!localStorage.getItem('mw_instant_tradein'); } catch(e) { return false; }
  }

  function clearLocalStorageTradeIn() {
    try {
      STORAGE_KEYS.forEach(function(k) { localStorage.removeItem(k); });
      sessionStorage.removeItem(DECLINED_KEY);
    } catch(e) {}
  }

  // Wait for pubsub subscribe function to be available
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function') return;

    subscribe('cart-update', function (event) {
      // Only act if localStorage has trade-in data
      if (!hasStoredTradeIn()) return;

      // Check if any item in the updated cart still has trade-in applied
      var items = (event && event.cartData && event.cartData.items) || [];
      var tradeInStillInCart = items.some(function (item) {
        return item.properties && (
          item.properties['Trade-in Amount'] ||
          item.properties['Trade-in Details']
        );
      });

      // No trade-in left in cart — main product was removed — clear storage
      if (!tradeInStillInCart) {
        clearLocalStorageTradeIn();
      }
    });
  });
})();
// ─── End Trade-In: clear localStorage on product remove ──────────────────────


// ─── Trade-In: persist "No trade-in" decision across page reload ──────────────
// Problem: the hidden input #main-pro-trade-in always has value="true" for eligible
// products (set in product-trade-in.liquid). This means _tradeInEligible is always
// stamped on ATC even when the consumer explicitly chose "No trade-in" on PDP.
// The page reloads after "No trade-in" is selected, wiping the DOM state — so we
// persist the decision in sessionStorage and clear the hidden input on reload.
(function initTradeInDeclinedGuard() {
  var DECLINED_KEY = 'machines-trade-in-declined';

  // On page load: if consumer previously chose "No trade-in", clear the
  // eligibility hidden input so _tradeInEligible is NOT stamped on ATC.
  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem(DECLINED_KEY) !== 'true') return;
    var input = document.getElementById('main-pro-trade-in');
    if (input) input.value = '';
  });

  // Listen for PDP trade-in radio option changes.
  // First radio (js-trade-in-modal-trigger-input) = "Start trade-in"
  // Any other radio with same name = "No trade-in"
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.name !== 'trade_in_pdp_radio_option') return;

    if (input.classList.contains('js-trade-in-modal-trigger-input')) {
      // Consumer chose "Start trade-in" — clear declined flag
      sessionStorage.removeItem(DECLINED_KEY);
    } else {
      // Consumer chose "No trade-in" — save declined flag so it
      // survives the page reload that follows
      sessionStorage.setItem(DECLINED_KEY, 'true');
    }
  });
})();
// ─── End Trade-In: persist "No trade-in" decision ────────────────────────────


// ─── Trade-In: cleanup duplicate trade-in items on cart load ─────────────────
// Problem: two separate Remobie API submissions (e.g. from two modals opened on
// different products) each write their own quotation ID and trade-in details to
// different cart line items. Sequential fix in updateCartLineItems() prevents
// NEW duplicates but cannot clear items stamped by a prior, separate submission.
// Fix: on cart page/drawer load, fetch /cart.js, find all items with Trade-in
// Details, keep only the one matching localStorage quotation_id, and clear the
// rest via sequential /cart/change.js calls before reloading.
(function initTradeInDuplicateCleanup() {
  var STORAGE_KEY = 'mw_instant_tradein';

  function getSavedQuotationId() {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return data && data.quotation_id ? String(data.quotation_id) : null;
    } catch(e) { return null; }
  }

  function clearItemTradeIn(item) {
    var props = {};
    Object.keys(item.properties || {}).forEach(function(k) { props[k] = item.properties[k]; });
    props['Trade-in Amount']  = '';
    props['Trade-in Details'] = '';
    props['_Quotation_id']    = '';
    props['_tradeInStatus']   = '';
    props['_tradeIn_device']  = '';
    props['_tradeIn_value']   = '';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, properties: props }),
    }).then(function(r) { return r.json(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Only run on cart page or when cart drawer is present
    if (!document.querySelector('.main-cart-items, cart-drawer-items')) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsWithTradeIn = (cart.items || []).filter(function(item) {
          return item.properties && item.properties['Trade-in Details'];
        });

        // Nothing to clean up
        if (itemsWithTradeIn.length <= 1) return;

        // Identify the authoritative item by matching localStorage quotation_id
        var savedQid = getSavedQuotationId();
        var primaryItem = itemsWithTradeIn[0]; // fallback: first item
        if (savedQid) {
          var match = itemsWithTradeIn.filter(function(item) {
            return item.properties && item.properties['_Quotation_id'] === savedQid;
          })[0];
          if (match) primaryItem = match;
        }

        // Clear trade-in from all other items sequentially to avoid cart race conditions
        var toClear = itemsWithTradeIn.filter(function(item) {
          return item.key !== primaryItem.key;
        });

        return toClear.reduce(function(chain, item) {
          return chain.then(function() { return clearItemTradeIn(item); });
        }, Promise.resolve()).then(function() {
          window.location.reload();
        });
      })
      .catch(function() {});
  });
})();
// ─── End Trade-In: cleanup duplicate trade-in items ──────────────────────────


// [MACHINES CUSTOM] - Limited availability / social proof counter
// Shows "X people are viewing this product". Count is random: 50–100 before 10am, 100–200 after.
// Refreshes every 5 seconds. Runs on any page that renders convx__limited-availability snippet.
(function () {
  function generatePersonCount() {
    var now = new Date();
    if (now.getHours() < 10) {
      return Math.round(Math.random() * 50) + 50;
    } else {
      return Math.round(Math.random() * 100) + 100;
    }
  }

  function initLimitedAvailability() {
    var countEls = document.querySelectorAll('.convx__limited-availability-count');
    if (!countEls.length) return;
    countEls.forEach(function (el) {
      el.textContent = generatePersonCount();
    });
    setInterval(function () {
      countEls.forEach(function (el) {
        el.textContent = generatePersonCount();
      });
    }, 5000);
  }

  document.addEventListener('DOMContentLoaded', initLimitedAvailability);
})();
// ─── End limited availability counter ────────────────────────────────────────